/**
 * Option component
 * 
 */

import React, { PureComponent } from 'react';

export default class Option extends PureComponent {
	
	static displayName = 'option';

	render() {

		const { children: label, type, id, name, value, checked, update, i } = this.props;

		switch (type) {

			case 'radio':
				return (

					<label className={checked === value ? 'checked' : ''} htmlFor={id + '-' + i}><input type={type} className="is-inverted" name={name} id={id + '-' + i} onChange={update} checked={checked === value} value={value} /> {label}</label>
				)

			case 'checkbox':
				return (

					<label className={checked === value ? 'checked' : ''} htmlFor={id + '-' + i}><input type={type} className="is-inverted" name={name} id={id + '-' + i} onChange={update} checked={checked === value} value={value} /> {label}</label>
				)

			case 'option':
				return (

					<option value={value}>{label}</option>
				)

			default:
				return ''
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/forms/fields/option.js